import styled from 'styled-components'

const RowGroup = styled.div`
  margin-bottom: 8px;
`
export default RowGroup